import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "../../../../components";
import {
  createBackup,
  createBackupFull,
  getBackupProgress,
} from "../../services/dataWarehouse.service";
import { Progress } from "antd";
import { PiCheckSquareBold } from "react-icons/pi";
import { Store } from "react-notifications-component";
import { clearSelectTable } from "../../redux/actions";

const BackUp = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isBackUpFull, setIsBackUpFull] = useState(false);
  const [progress, setProgress] = useState(0);

  const { dbTypes, selectDB, selectTable, selectDatabase } = useSelector(
    ({ warehouseReducer }) => warehouseReducer
  );

  const dispatch = useDispatch();

  const onClickBackup = async () => {
    try {
      setIsLoading(true);
      let body = {
        db_type: dbTypes.find((dbType) => dbType.value === selectDB)
          ?.displayValue,
        db_name: selectDatabase,
        config_file: selectDB,
        table_name: selectTable,
      };

      const response = await createBackup(body);
      const backupId = response?.data?.backup_id;
      if (!backupId) return;

      const interval = setInterval(async () => {
        const progressResponse = await getBackupProgress(backupId);
        setProgress(0);
        const percentage = progressResponse.data?.progress || 0;
        setProgress(percentage);

        if (percentage >= 100) {
          clearInterval(interval);
          setIsLoading(false);
          dispatch(clearSelectTable());
        }
      }, 1000);
    } catch (error) {
      console.error("Backup failed", error);
      setIsLoading(false);
    }
  };

  const onClickBackupFull = async () => {
    try {
      setIsLoading(true);
      let body = {
        db_type: dbTypes.find((dbType) => dbType.value === selectDB)
          ?.displayValue,
        db_name: selectDatabase,
        config_file: selectDB,
        table_name: selectTable,
      };

      const response = await createBackupFull(body);
      const backupId = response?.data?.backup_id;
      if (!backupId) return;

      const interval = setInterval(async () => {
        const progressResponse = await getBackupProgress(backupId);
        setProgress(0);
        const percentage = progressResponse.data?.progress || 0;
        setProgress(percentage);

        if (percentage >= 100) {
          clearInterval(interval);
          setIsLoading(false);
        }
      }, 1000);
    } catch (error) {
      console.error("Backup failed", error);
      setIsLoading(false);
    }
  };

  return (
    <>
      <div className="jb-category-body-wrapper">
        <div className="wbw_welcome-body">
          <div
            className="wbw_wb-welcome-message"
            onClick={() => setIsBackUpFull(!isBackUpFull)}
          >
            {!isBackUpFull ? (
              <div className="icon">
                <PiCheckSquareBold />
              </div>
            ) : (
              "✅"
            )}{" "}
            Full Database
          </div>
          <>
            {!isLoading && (
              <Button
                data={{
                  mainLayerStyles: "",
                  btnName: "BackUp",
                  buttonType: "primary",
                  buttonSize: "xs",
                  isLoading: isLoading,
                  disable: false,
                }}
                onClick={async (e) => {
                  e.preventDefault();
                  if (isBackUpFull && selectTable === "") {
                    await onClickBackupFull();
                  } else if (selectTable && !isBackUpFull) {
                    await onClickBackup();
                  } else {
                    Store.addNotification({
                      title: "Error!",
                      message: "Select Table or Check the Full Database!",
                      type: "danger",
                      insert: "top",
                      container: "top-right",
                      dismiss: {
                        duration: 2000,
                        onScreen: true,
                      },
                    });
                  }
                }}
              />
            )}
            {progress > 0 && (
              <div
                className="d-flex flex-column justify-content-center align-items-center mt-3"
                style={{ width: "320px" }}
              >
                <Progress
                  percent={progress}
                  showInfo={false}
                  strokeColor=" #C40B4A"
                  trailColor=" #FA1C690A"
                />
                <span className="mt-2">{progress}%</span>
              </div>
            )}
          </>
        </div>
      </div>
    </>
  );
};
export default withRouter(BackUp);
